var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog-no-footer",
      attrs: {
        visible: _vm.visible,
        width: "80%",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: { "update:visible": (val) => _vm.emitUpdateVisible(val) },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "MemberUidHeader",
                {
                  attrs: {
                    username: _vm.targetInfo.username,
                    uid: _vm.uid,
                    "vip-level": _vm.targetInfo.vip_level,
                  },
                },
                [
                  _c("span", { staticClass: "dialog-subtitle" }, [
                    _vm._v("提现记录"),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.active
        ? _c("ManageWithdrawInfoTabV2", {
            attrs: {
              "target-info": _vm.targetInfo,
              "is-active": _vm.active,
              "reset-key": _vm.resetKey,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }